import { useContext, useEffect, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
// import Typography from '@mui/material/Typography';
import { MdExpandMore } from 'react-icons/md';
import ShortAnswer from './manage/Main/ShortAnswer';
import MCQ from './manage/Main/MCQ';
import FillInTheBlanks from './manage/Main/FillInTheBlanks';
import MatchTheFollowing from './manage/Main/MatchTheFollowing';
import SubQuestions from './manage/Main/SubQuestions';
// import { makeStyles } from '@material-ui/core/styles';
import * as AppPics from 'assets/images';
import { AppButton } from 'components';
import { AiOutlineComment } from 'react-icons/ai';
import { UserContext } from 'context/UserContext';
import { ROLES } from 'utilities/constants';
import TutorRating from 'components/TutorRating';
import { Link } from 'react-router-dom';
import Rating from '@mui/material/Rating';

function AccordionListing(props) {
  const { index, item = {}, handleQuizQuestion, deleteConfig, fns, accord = {}, total } = props;
  const { userInfo = {} } = useContext(UserContext);
  const { key } = userInfo?.data ?? {};
  const [category, setCategory] = useState('single');
  const { setCopyMode, handleClone, handleRating } = fns || {};

  const { expanded, handleAccordChange, setQBox } = accord;

  useEffect(() => {
    if (item?._id) {
      if (item?.category) setCategory(item.category);
    }
  }, [item]);

  let hideSaveBtn = key === ROLES.SUBJECT_EXPERT && item?.quiz?.isQuizUnderReview;
  if (!hideSaveBtn) hideSaveBtn = item?.isUnderReview;

  if (!hideSaveBtn) {
    hideSaveBtn =
      key === ROLES.SUBJECT_EXPERT &&
      item?.quiz?.chapter?.reviewStatusOfChapterQuizAsses === 'qc_review';
  }
  // hideSaveBtn is true; then check if delete, clone & copy is laos not working

  let __border = {};
  if (item?.reviewComment?.respondentResolve && key === ROLES.SUBJECT_EXPERT) {
    __border = { border: '1px solid green' };
  } else if (item?.reviewComment?.resolved && [ROLES.QC, ROLES.TUTOR].includes(key)) {
    __border = { border: '1px solid green' };
  } else if (
    item?.reviewComment?.issueType?.includes?.('no_issues') &&
    [ROLES.QC, ROLES.TUTOR, ROLES.SUBJECT_EXPERT].includes(key)
  ) {
    __border = { border: '1px solid green' };
  } else if (item?.reviewComment?._id) {
    __border = { border: '1px solid red' };
  }

  const isTeacher = userInfo?.data?.key === ROLES.TUTOR;

  return (
    <>
      <Accordion
        expanded={item?._id === expanded}
        onChange={handleAccordChange(item?._id)}
        id={item?._id}
      >
        <AccordionSummary
          expandIcon={<MdExpandMore />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          {/* <Typography>
            Question {index}:: <Text questionType={item.questionType} category={item.category} />
          </Typography> */}
          <div
            className="lessonWrap lessonWrap--border question__list ___noDrag"
            style={{ ...__border }}
          >
            <div className="lessonWrap__text">
              <span className="lessonWrap__name">
                Question {index}::{' '}
                <Text questionType={item.questionType} category={item.category} />
                {item?.ratings?.currentRating && (
                  <Rating
                    name="read-only"
                    value={item?.ratings?.currentRating}
                    readOnly
                    precision={0.5}
                    className="mx-4"
                    title={'You have received' + item?.ratings?.currentRating}
                  />
                )}
              </span>
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <div className="d-flex justify-content-between">
            <div className="mx-4 px-4 text-right">
              {!item?.ratings?.currentRating && (
                <TutorRating
                  ratingValue={item?.ratings?.currentRating}
                  starProps={{ readOnly: !!item?.ratings?.currentRating }}
                  apiArgs={{ questionID: item?._id, quizID: item?.quiz?._id, type: 'question' }}
                />
              )}
              {isTeacher && item?.ratings?.currentRating && (
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() => {
                    handleRating({
                      currentRating: item?.ratings?.currentRating,
                      apiArgs: {
                        questionID: item?._id,
                        quizID: item?.quiz?._id,
                        type: 'question',
                      },
                    });
                  }}
                >
                  Change rating
                </button>
              )}
            </div>
            <div className="mx-4 px-4 text-right">
              {/* <AppButton
                variantClass="btn-plane g--tint"
                onClick={(e) => {
                  e.preventDefault();
                  window.open(
                    `${process.env.REACT_APP_PREVIEW_URL}/quiz/preview?questionId=${item?._id}`,
                    'edpodia_preview'
                  );
                }}
              >
                Live Preview{' '}
              </AppButton> */}
              <a
                href={`${process.env.REACT_APP_PREVIEW_URL.replace(/\/$/, '')}/sneak-peak/quiz?questionId=${item?._id}&qIndex=${index}&qTotal=${total}`}
                role={'button'}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-plane g--tint"
              >
                {' '}
                Live Preview{' '}
              </a>

              {([ROLES.ADMIN, ROLES.TUTOR, ROLES.QC].includes(key) ||
                (key === ROLES.SUBJECT_EXPERT && item?.reviewComment?._id)) && (
                <AppButton
                  variantClass="lessonWrap__btn"
                  style={{ fontSize: '22px', verticalAlign: 'middle' }}
                  onClick={() => {
                    setQBox({ open: true, data: { ...item, index } });
                  }}
                >
                  <AiOutlineComment color="#7e1f8c" />
                </AppButton>
              )}
              {[ROLES.ADMIN, ROLES.SUBJECT_EXPERT].includes(key) && (
                <>
                  <AppButton
                    variantClass="lessonWrap__btn"
                    title="Copy"
                    onClick={() => {
                      setCopyMode();
                    }}
                  >
                    <img src={AppPics.CopySvg} alt="" />
                  </AppButton>
                  <AppButton
                    variantClass="lessonWrap__btn"
                    title="Clone"
                    onClick={() => {
                      handleClone?.();
                    }}
                  >
                    <img src={AppPics.StampSvg} alt="" />
                  </AppButton>
                  {deleteConfig?.showBtn && (
                    <AppButton
                      variantClass="lessonWrap__btn"
                      onClick={() => deleteConfig?.handleDelete()}
                      title="Delete"
                    >
                      <img src={AppPics.TrashBinSvg} alt="" />
                    </AppButton>
                  )}
                </>
              )}
            </div>
          </div>

          {item.questionType === 'short' && (
            <ShortAnswer
              data={{ data: item }}
              editMode={true}
              handleSave={handleQuizQuestion}
              configs={{
                hideSaveBtn,
                hideTopBtnSection: true,
                deleteConfig,
                showRating: isTeacher,
              }}
              // toggleView={[showForm, toggleShowForm]}
              // selectedCategory={[category, setCategory]}
            />
          )}
          {item.questionType === 'choice' && (
            <MCQ
              data={{ data: item }}
              editMode={true}
              handleSave={handleQuizQuestion}
              configs={{
                hideSaveBtn,
                hideTopBtnSection: true,
                UID: item._id,
                deleteConfig,
                showRating: isTeacher,
              }}
              // toggleView={[showForm, toggleShowForm]}
              selectedCategory={[category, setCategory]}
            />
          )}
          {item.questionType === 'fill' && (
            <FillInTheBlanks
              data={{ data: item }}
              editMode={true}
              handleSave={handleQuizQuestion}
              configs={{
                hideSaveBtn,
                hideTopBtnSection: true,
                deleteConfig,
                showRating: isTeacher,
              }}
              // toggleView={[showForm, toggleShowForm]}
              // selectedCategory={[category, setCategory]}
            />
          )}
          {item.questionType === 'match' && (
            <MatchTheFollowing
              data={{ data: item }}
              editMode={true}
              handleSave={handleQuizQuestion}
              configs={{
                hideSaveBtn,
                hideTopBtnSection: true,
                deleteConfig,
                showRating: isTeacher,
              }}
              // toggleView={[showForm, toggleShowForm]}
              // selectedCategory={[category, setCategory]}
            />
          )}
          {item.questionType === 'subQuestions' && (
            <SubQuestions
              data={{ data: item }}
              editMode={true}
              handleSave={handleQuizQuestion}
              configs={{
                hideSaveBtn,
                hideTopBtnSection: true,
                deleteConfig,
                showRating: isTeacher,
              }}
              // toggleView={[showForm, toggleShowForm]}
              // selectedCategory={[category, setCategory]}
            />
          )}
        </AccordionDetails>
      </Accordion>
    </>
  );
}

function Text({ questionType, category }) {
  if (questionType === 'choice')
    return (
      <>
        <strong>MCQ</strong>({category})
      </>
    );
  if (questionType === 'fill')
    return (
      <>
        <strong>Fill in the blanks</strong>
      </>
    );
  if (questionType === 'match')
    return (
      <>
        <strong>Match the following</strong>
      </>
    );
  if (questionType === 'short')
    return (
      <>
        <strong>Short answer</strong>
      </>
    );
  if (questionType === 'subQuestions')
    return (
      <>
        <strong>SubQuestions</strong>
      </>
    );

  return null;
}

export default AccordionListing;
